// offer-details-modal.js
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("offer-details-myModal");
  const triggers = document.querySelectorAll(".detailPop");
  const closeBtn = modal.querySelector(".offer-details-close");
  let lastFocused;
  let savedScrollY;

  function trapFocus(e) {
    const focusable = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0],
      last = focusable[focusable.length - 1];
    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Escape") closeModal();
    else trapFocus(e);
  }

  function openModal(e) {
    e.preventDefault(); // stop the href="#"
    lastFocused = document.activeElement;
    
    // --- 2. Save scroll position and set CSS variable ---
    savedScrollY = window.scrollY;
    document.documentElement.style.setProperty('--scroll-lock-top', `-${savedScrollY}px`);
    // ----------------------------------------------------

    modal.hidden = false;
    document.body.classList.add("modal-open"); // This class now does more
    closeBtn.focus();
    document.addEventListener("keydown", handleKeyDown);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove("modal-open");
    
    // --- 3. Restore scroll position ---
    document.documentElement.style.removeProperty('--scroll-lock-top');
    window.scrollTo(0, savedScrollY);
    // ----------------------------------

    document.removeEventListener("keydown", handleKeyDown);
    lastFocused?.focus();
  }

  triggers.forEach((btn) => btn.addEventListener("click", openModal));
  closeBtn.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
});
